import React from "react";
import { DayTimeInput } from "@sinch/components/form/DayTimeInput/DayTimeInput";
import { DayTimeInputProps } from "@sinch/components/form/DayTimeInput/types";
import { usePopoverContext } from "@sinch/components/providers/PopoverProvider";

export const StringTimeInput = ({
  value,
  onChange,
  timePoint,
  ...props
}: Omit<DayTimeInputProps, "value" | "onChange"> & {
  value: string | null;
  onChange?: (val: string) => void;
}) => {
  const isInPopover = usePopoverContext();

  return (
    <DayTimeInput
      disablePortal={!isInPopover}
      onChange={(val) => onChange?.(val ?? "00:00")}
      timePoint={timePoint ?? undefined}
      value={value}
      {...props}
    />
  );
};
